import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'striphtml',
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: any): any {
    if (!value || typeof value !== 'string') return value || '';

    let text = value;

    // Use browser native DOMParser to strip HTML tags and decode standard entities (&nbsp;, &amp;, &lt;, etc.)
    if (typeof document !== 'undefined') {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        text = doc.body.textContent || doc.body.innerText || '';
      } catch (e) {
        text = text.replace(/<.*?>/g, '');
      }
    } else {
      text = text.replace(/<.*?>/g, '');
    }

    // Clean up any remaining raw 'nbsp;', '&nbsp;', non-breaking space characters (\u00A0), and normalize spaces
    return text
      .replace(/&?nbsp;/gi, ' ')
      .replace(/\u00A0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
}
